import { PregnancyState, PregnantWith, ProfileEntity, SexType } from "@/mk2/apps/settings/schemas";
import { entitiesWithPhotoPropToSuccessfulPhotoUploads } from "@/mk2/helpers/photos";
import { PhotoEntity } from "@/mk2/schemas";

export const SETTINGS_PROFILE_FORM_NAME = "SETTINGS_PROFILE_FORM";

export interface ProfileFormData {
    photos: PhotoEntity[];
    sex: SexType;
    birthDate: string;
    locationCounty: string;
    place: string;
    pregnancyState: PregnancyState;
    dueDate: string;
    pregnantWith: PregnantWith;
    childName: string;
    about: string;
    avatarCrop: any;
}

export function getProfileFormInitialValues(profile: ProfileEntity): ProfileFormData {
    const photos = entitiesWithPhotoPropToSuccessfulPhotoUploads(profile.photos || []);
    return {
        photos,
        sex: profile.sex,
        birthDate: profile.birthDate,
        locationCounty:
            !profile.locationCounty && !!profile.place
                ? "0"
                : profile.locationCounty?.id.toString(),
        place: profile.place?.id.toString(),
        pregnancyState: profile.pregnancyState,
        pregnantWith: profile.pregnantWith,
        dueDate: profile.dueDate,
        childName: profile.childName,
        about: profile.about,
        // avatarCrop: [xPosition, yPosition, width],
        avatarCrop: [0, 0, 100],
    };
}
